import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LoggingService {

  private readonly logLevels = {
    DEBUG: 'debug',
    INFO: 'info',
    WARN: 'warn',
    ERROR: 'error',
  };

  constructor() { }

  /** Logs informational messages */
  logInfo(message: string, data?: any): void {
    this.log(this.logLevels.INFO, message, data);
  }

  /** Logs error messages and optional error objects */
  logError(message: string, error?: any): void {
    let errorDetails = '';
    if (error instanceof Error) {
      errorDetails = `${error.name}: ${error.message}\n${error.stack}`;
    } else if (typeof error === 'string') {
      errorDetails = error;
    } else if (error) {
      errorDetails = JSON.stringify(error, null, 2);
    }

    const fullMessage = errorDetails ? `${message}\nDetails: ${errorDetails}` : message;
    this.log(this.logLevels.ERROR, fullMessage);
  }

  /** Logs debug messages */
  logDebug(message: string, data?: any): void {
    this.log(this.logLevels.DEBUG, message, data);
  }

  /** Logs warning messages */
  logWarn(message: string, data?: any): void {
    this.log(this.logLevels.WARN, message, data);
  }

  /** Central logging method with flexible handling */
  private log(level: string, message: string, data?: any): void {
    const time = new Date().toISOString();
    const formattedMessage = `[${level.toUpperCase()}] [${time}] ${message}`;

    switch (level) {
      case this.logLevels.INFO:
        data ? console.info(formattedMessage, data) : console.info(formattedMessage);
        break;
      case this.logLevels.ERROR:
        data ? console.error(formattedMessage, data) : console.error(formattedMessage);
        break;
      case this.logLevels.DEBUG:
        data ? console.debug(formattedMessage, data) : console.debug(formattedMessage);
        break;
      case this.logLevels.WARN:
        data ? console.warn(formattedMessage, data) : console.warn(formattedMessage);
        break;
      default:
        data ? console.log(formattedMessage, data) : console.log(formattedMessage);
        break;
    }
  }
}
